import { Divider, Tag } from 'antd';
import './index.scss';
import {
  addCommas,
  capitalizeFirstLetter,
  getPriceText,
} from '@zorba-shared/core/Services/textService';
import _ from 'lodash';
import { DEFAULT_FEE_AMOUNT } from '@zorba-shared/core/Constants/offer';
import { PROPERTY_TYPE_TITLES } from '@zorba-shared/core/Constants/deal';

const items = [
  {
    title: () => 'Market',
    value: ({ selectedOffer }) => selectedOffer?.matchedBuyBox?.title,
  },
  {
    title: () => 'County',
    value: ({ dealSubmission }) => `${dealSubmission.address.county}`,
  },
  {
    title: () => 'Type',
    value: ({ dealSubmission }) =>
      PROPERTY_TYPE_TITLES[dealSubmission?.lastCalculationParams?.propertyType],
  },
  {
    title: () => 'Bedrooms',
    value: ({ dealSubmission }) =>
      `${dealSubmission.lastCalculationParams.bedroom}`,
  },
  {
    title: () => 'Bathrooms',
    value: ({ dealSubmission }) =>
      `${dealSubmission.lastCalculationParams.bathroom}`,
  },
  {
    title: () => 'SqFt',
    value: ({ dealSubmission }) =>
      `${addCommas(dealSubmission.lastCalculationParams.squareFootage)}`,
  },
  {
    title: () => 'Lot size',
    value: ({ dealSubmission }) =>
      `${addCommas(dealSubmission.lastCalculationParams.lotSize)}`,
  },
  {
    title: () => 'Year built',
    value: ({ dealSubmission }) =>
      `${dealSubmission.lastCalculationParams.yearBuilt}`,
  },
  {
    title: ({ doesIncludeFeeInOffer, isCustomMarketplace }) =>
      doesIncludeFeeInOffer && !isCustomMarketplace
        ? `Seller's asking price (including our fee)`
        : `Seller's asking price`,
    value: ({ dealSubmission, feeAmount, doesIncludeFeeInOffer }) => {
      const lastAskingPrice =
        dealSubmission?.userData?.updatedAskingPrice?.length > 0
          ? dealSubmission.userData?.updatedAskingPrice[
              dealSubmission.userData.updatedAskingPrice.length - 1
            ]?.price
          : dealSubmission.userData?.askingPrice;

      return doesIncludeFeeInOffer
        ? getPriceText(lastAskingPrice + (feeAmount || DEFAULT_FEE_AMOUNT))
        : getPriceText(lastAskingPrice);
    },
  },
  {
    title: () => `Occupancy`,
    value: ({ dealSubmission }) =>
      dealSubmission.userData.occupancy
        ? capitalizeFirstLetter(dealSubmission.userData.occupancy)
        : '',
  },
  {
    title: () => `Has pool?`,
    value: ({ dealSubmission }) =>
      [null, undefined].includes(dealSubmission.lastCalculationParams.hasPool)
        ? 'N/A'
        : `${dealSubmission.lastCalculationParams.hasPool ? 'Yes' : 'No'}`,
  },
  {
    title: () => `Parking`,
    value: ({ dealSubmission }) =>
      dealSubmission.lastCalculationParams.parkingSpaces,
  },
  {
    title: () => `Flood zone`,
    value: ({ dealSubmission }) =>
      dealSubmission.lastCalculationParams.floodZone,
  },
  {
    title: () => `HOA`,
    value: ({ dealSubmission }) =>
      [null, undefined].includes(dealSubmission?.userData?.hoaFee)
        ? 'N/A'
        : dealSubmission?.userData?.hoaFee
        ? `${getPriceText(dealSubmission?.userData?.hoaFee)}/${
            dealSubmission?.userData?.hoaPeriod
          }`
        : '$0',
  },
  {
    title: () => 'Estimated rent',
    value: ({ dealSubmission }) =>
      dealSubmission?.userData?.rent ||
      dealSubmission?.lastCalculationParams?.grossRent
        ? getPriceText(
            parseInt(
              dealSubmission?.userData?.rent ||
                dealSubmission?.lastCalculationParams?.grossRent,
              10,
            ),
          )
        : 'N/A',
  },
  {
    title: () => `Photos/Videos`,
    value: ({ dealSubmission }) => (
      <a
        href={`https://buy.getzorba.com/deal/photos/${dealSubmission?._id}`}
        target="_blank"
        rel="noreferrer"
      >
        View
      </a>
    ),
  },
  {
    title: () => `Zillow`,
    value: ({ dealSubmission }) => (
      <a
        href={`https://www.zillow.com${dealSubmission?.zillowData?.hdpUrl}`}
        target="_blank"
        rel="noreferrer"
      >
        View
      </a>
    ),
  },
  // {
  //   title: () => `Zorba's renovation report`,
  //   value: ({ dealSubmission }) => dealSubmission?.underwriting?.renovationReportUrl ? (
  //     <a
  //       href={dealSubmission?.underwriting?.renovationReportUrl}
  //       target="_blank"
  //       rel="noreferrer"
  //     >
  //       View
  //     </a>
  //   ) : '-',
  // },
];

export default (props) => {
  const { selectedOffer, doesIncludeFeeInOffer, isCustomMarketplace } = props;
  const chunks = _.chunk(items, items.length / 2 + 1);

  return (
    <div className="property-details-tab">
      <h3>Overview</h3>
      <Divider />
      <div className="row">
        <div className="left">
          <div className="item">
            <div className="key">Source</div>
            <div className="value">
              <Tag>
                {selectedOffer?.dealSubmission?.kind === 'pre-deal'
                  ? 'Pre-Lock'
                  : 'Wholesale'}
              </Tag>
            </div>
          </div>
          {chunks[0].map((item) => (
            <div className="item">
              <div className="key">{item.title({ doesIncludeFeeInOffer })}</div>
              <div className="value">
                {item.value({
                  selectedOffer,
                  dealSubmission: selectedOffer.dealSubmission,
                  doesIncludeFeeInOffer,
                  feeAmount: selectedOffer.feeAmount,
                })}
              </div>
            </div>
          ))}
        </div>
        <div className="right">
          {chunks[1].map((item) => (
            <div className="item">
              <div className="key">
                {item.title({ doesIncludeFeeInOffer, isCustomMarketplace })}
              </div>
              <div className="value">
                {item.value({
                  selectedOffer,
                  dealSubmission: selectedOffer.dealSubmission,
                  doesIncludeFeeInOffer,
                  feeAmount: selectedOffer.feeAmount,
                  isCustomMarketplace,
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
